import {charcoal} from '../../sass/v2/_exports.sass';

export const StarLineIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.227 19.718l-2.384 10.321c-0.074 0.312-0.052 0.64 0.064 0.94s0.318 0.558 0.582 0.74c0.264 0.183 0.577 0.281 0.898 0.283s0.635-0.093 0.902-0.272l8.71-5.807 8.71 5.807c0.273 0.181 0.594 0.274 0.921 0.267s0.644-0.114 0.908-0.307c0.264-0.193 0.463-0.462 0.57-0.771s0.116-0.644 0.028-0.958l-2.926-10.238 7.256-6.53c0.232-0.209 0.398-0.482 0.477-0.785s0.068-0.622-0.033-0.918-0.285-0.556-0.532-0.749c-0.247-0.192-0.544-0.308-0.856-0.332l-9.12-0.726-3.946-8.736c-0.126-0.281-0.33-0.52-0.589-0.688s-0.56-0.257-0.868-0.257c-0.308 0-0.61 0.089-0.868 0.257s-0.463 0.406-0.589 0.688l-3.946 8.736-9.12 0.725c-0.306 0.024-0.599 0.136-0.844 0.323s-0.43 0.439-0.534 0.728c-0.104 0.289-0.123 0.602-0.055 0.902s0.222 0.573 0.443 0.788l6.741 6.57zM11.791 12.798c0.286-0.023 0.56-0.121 0.794-0.286s0.42-0.39 0.537-0.651l2.878-6.368 2.878 6.368c0.117 0.261 0.303 0.486 0.537 0.651s0.508 0.264 0.794 0.286l6.354 0.504-5.233 4.71c-0.454 0.41-0.635 1.040-0.469 1.628l2.004 7.015-5.976-3.985c-0.262-0.176-0.571-0.27-0.887-0.27s-0.625 0.094-0.887 0.27l-6.245 4.164 1.68-7.272c0.062-0.267 0.053-0.546-0.024-0.81s-0.221-0.502-0.418-0.694l-4.86-4.738 6.543-0.522z"
        fill={color}
      />
    </svg>
  );
};
